import { createContext } from 'react';
import tradingStore from './store';

export interface TradingContextValue {
  tradingStore: ReturnType<typeof tradingStore> | null;
}

export const TradingContext = createContext<TradingContextValue>({
  tradingStore: null,
});

export default TradingContext;
